<div class="item" (click)="itemClicked()">
    <div class="p-paragraph-1 p-tpgr-medium headline">{{ data.typeName }} {{ data.appId }}</div>
    <p-link
        [attr.automation-id]="'recently-viewed-item-link'"
        (click)="itemLinkClicked()"
        [isRouterLink]="true"
        [url]="data.url"
        [queryParams]="data.queryParams"
        >{{ data.title }}</p-link
    >
</div>
